import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { IoAddOutline } from "react-icons/io5";
import { MdDeleteForever } from "react-icons/md";
import { AxiosResponse } from "axios";
import { Modal, Button } from "rsuite";
import { axiosPatch } from "../../common/utils/helper";
import { EPInput } from "../../common/controls/input";
import { rejectRequest } from "../../common/utils/api";
import { toast } from "react-toastify";
import "./manageRequest.scss";
import { CommonConstants } from "../../common/utils/CommonConstants";
import Loader from "../Loader/loader";
interface Props {
  open: boolean;
  setOpen: Function;
  RequirementId: number;
  data: Array<any>;
  setDataList: React.Dispatch<React.SetStateAction<any[]>>;
}

function RejectRequestModal(props: Props) {
  const { open, setOpen, RequirementId, data, setDataList } = props;
  const [reason, setReason] = useState("");
  const [isValidate, setIsValidate] = useState(false);
  const [loading, setLoading] = useState<boolean>(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = () => {
    setIsValidate(true);
    if (reason.trim()) {
      const Data = {
        id: RequirementId,
        reason: reason,
      };
      postRejectRequest(rejectRequest, Data);
    }
  };

  const postRejectRequest = async (reqUrl: string, reqBody: {}) => {
    setLoading(true);
    const response = (await axiosPatch(reqUrl, reqBody)) as AxiosResponse;
    if (response.status === CommonConstants.API_RESPONSE_SUCCESSFULL) {
      setLoading(false);
      const searchIndex = data.findIndex(
        (obj) => obj.RequirementId === RequirementId
      );
      // update the grid data
      if (searchIndex !== -1) {
        let list = [...data];
        list[searchIndex].StatusName = "Cancel";
        setDataList(list);
      }

      const message = "Request rejected Successfully.";
      toast.success(message, {
        position: toast.POSITION.TOP_CENTER,
      });
      handleClose();
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <Modal open={open} onClose={handleClose} className="modal-sm" backdrop="static" keyboard={false}>
      <Modal.Header closeButton={true}>Reject Request</Modal.Header>
      <Modal.Body>
        <Row>
          <Col xs lg="12" className="recruiter-label">
            Reject Reason<span className="req">*</span>
          </Col>
          <Col xs lg="12" className="recruiter-label">
            <EPInput
              textType="textarea"
              rows={3}
              maxlength={1000}
              onChange={(value: string) => setReason(value)}
              value={reason}
              isValidate={isValidate}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="pt-3">
        <Row>
          <Col xs lg>
            <Button
              type="button"
              onClick={() => handleSubmit()}
              className="outline-primary float-start mb-3 ms-1 px-4"
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}

export default RejectRequestModal;
